"use strict";
import { useSyncExternalStore } from "react";
import { logger } from "utilities/src/logger/logger";
const initialState = {
  walletAddress: null,
  chainId: null,
  isConnected: false
};
const embeddedWalletStateKey = "embedded-wallet";
let state = initialState;
const listeners = /* @__PURE__ */ new Set();
const getSnapshot = () => state;
const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
const setState = (updates) => {
  state = { ...state, ...updates };
  listeners.forEach((listener) => listener());
  localStorage.setItem(embeddedWalletStateKey, JSON.stringify(state));
};
try {
  const persisted = localStorage.getItem(embeddedWalletStateKey);
  if (persisted) {
    state = JSON.parse(persisted);
  }
} catch (e) {
  logger.info("embeddedWallet", "store", `No existing embedded wallet state found for key ${embeddedWalletStateKey}`);
}
export function useEmbeddedWalletState() {
  const currentState = useSyncExternalStore(subscribe, getSnapshot);
  return {
    ...currentState,
    setWalletAddress: (address) => setState({ walletAddress: address }),
    setChainId: (chainId) => setState({ chainId }),
    setIsConnected: (isConnected) => setState({ isConnected })
  };
}
export function getEmbeddedWalletState() {
  return getSnapshot();
}
export function setChainId(chainId) {
  setState({ chainId });
}
